export const description =
  "MaPrimeRénov’ 2026 : guide complet de l'aide de l'Anah. Les 3 volets (Décarbonation, Ampleur, Copropriétés), plafonds de ressources Île-de-France et hors IDF, montants par geste, démarches, cumul prime énergie + éco-PTZ + TVA 5,5 %. Mis à jour selon le barème Anah 1ᵉʳ janvier 2026.";
